import {BotaoSalvar, PaginaLogada, SelectFetch} from "../../componentes";
import React, {useEffect, useState} from "react";
import {CirastServico} from "../../servicos";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  HttpVerbo,
  xfetch
} from "../../util";
import {useNavigate} from "react-router-dom";
import {Card} from "react-bootstrap";



export default function CadastrarConsultaCirast() {

  const navegacao = useNavigate()
  const [instituicoes, setInstituicoes] = useState([])
  const [consulta, setConsulta] = useState({
    paciente: '',
    prontuario: '',
    cpfPaciente: '',
    idInstituicao: -1,
    idClinica: -1,
    tpAtendimento: '',
    dataHora: '',
    dataHoraFim: '',
    qtdSessoes: 0
  })
  const [isCarregando, setIsCarregando] = useState(false)

  function carregaInstituicoes() {
    setIsCarregando(true)
    xfetch('/forca', {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setInstituicoes(dados))
      .catch(() => exibirMensagemErro("Erro ao carregar instituições"))
  }

  useEffect(() => {
    carregaInstituicoes()
  }, [])

  function enviar() {
    setIsCarregando(true)
    CirastServico.cadastrarConsultaCirast(consulta)
      .then(res => res.json())
      .then(ok => {
        exibirMensagemSucesso("Consulta cadastrada com sucesso!");
        setConsulta({
          paciente: '',
          prontuario: '',
          cpfPaciente: '',
          idInstituicao: -1,
          idClinica: -1,
          profissional: '',
          cnpj: '',
          endereco: '',
          cep: '',
          tpAtendimento: '',
          dataHora: '',
          dataHoraFim: '',
          qtdSessoes: 0,
        })
        navegacao('/listarConsultasCirast')
      })
      .finally(() => setIsCarregando(false))
  }

  return (
    <PaginaLogada titulo="Cadastrar Consulta Cirast" setIsCarregando={setIsCarregando}>
      <Card className="mb-5">
        <Card.Body>
          <div className="row">
            <div className="col-lg-5">
              <label>Nome do paciente</label>
              <input
                autoComplete="off"
                className="form-control"
                value={consulta.paciente}
                onChange={(e) => setConsulta({...consulta, paciente: e.target.value.toUpperCase()})}
                placeholder="Nome do paciente"/>
            </div>
            <div className="col-lg-3">
              <label>Nº Prontuário</label>
              <input
                autoComplete="off"
                className="form-control"
                value={consulta.prontuario}
                onChange={(e) => setConsulta({...consulta, prontuario: e.target.value})}
                placeholder="Nome do paciente"/>
            </div>
            <div className="col-lg-3">
              <label>CPF do paciente:</label>
              <input
                autoComplete="off"
                className="form-control"
                value={consulta.cpfPaciente}
                onChange={(e) => setConsulta({...consulta, cpfPaciente: e.target.value.toUpperCase()})}
                placeholder="CPF do paciente"/>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-3">
              <label>Instituição do servidor:</label>
              <select className="form-control"
                onChange={(e) => setConsulta({...consulta, idInstituicao: e.target.value})}>
                <option value="-1">Selecione a instituição</option>
                {instituicoes.map((v, k) => {
                  return <option value={v.id} key={k}>{v.nome}</option>
                })}
              </select>
            </div>
            <div className="col-lg-4">
              <label>Clinica:</label>
              <SelectFetch
                handleChange={(v) => setConsulta({...consulta, idClinica: v.value})}
                url='/cirast/clinica/ativa'
                setIsCarregando={setIsCarregando}
                placeholder='Selecione a clinica' />
            </div>

            <div className="col-lg-2">
              <label>Tipo Atendimento:</label>
              <SelectFetch
                url={'/cirast/tipoAtendimento'}
                setIsCarregando={setIsCarregando}
                handleChange={(e) =>
                  console.log(e) & setConsulta({...consulta, tpAtendimento: e.value})}
                placeholder='Selecione o atendimento'/>
              {/*</select>*/}
            </div>
          </div>
          <div className="row mt-3 mb-5 align-items-end">
            <div className="col-lg-2">
              <label>Início da validade: </label>
              <input
                type="date"
                autoComplete="off"
                className="form-control"
                value={consulta.dataHora}
                onChange={(e) => setConsulta({...consulta, dataHora: e.target.value})}
                placeholder="Início da validade"/>
            </div>
            <div className="col-lg-2">
              <label>Fim da validade: </label>
              <input
                type="date"
                autoComplete="off"
                className="form-control"
                value={consulta.dataHoraFim}
                onChange={(e) => setConsulta({...consulta, dataHoraFim: e.target.value})}
                placeholder="Fim da validade"/>
            </div>
            <div className="col-lg-2">
              <label>Quantidade de sessões: </label>
              <input
                type="number"
                autoComplete="off"
                className="form-control"
                value={consulta.qtdSessoes}
                onChange={(e) => setConsulta({...consulta, qtdSessoes: Number.parseInt(e.target.value.toString())})}
                placeholder="Início da validade"/>
            </div>
            <div className="col-lg-2 mt-4">
              <BotaoSalvar onClick={enviar}/>
            </div>
          </div>
        </Card.Body>
      </Card>
    </PaginaLogada>
  )
}
